import React, { Component } from "react";
import InjectStore from "./InjectStore";
import { observer } from "mobx-react";
import CommentsPopover from "app/list/views/table/columnEditors/Triggers/CommentsPopover";

class ExtjsReact extends Component {
  constructor(props) {
    super(props);
    this.renderTo = Util.getUniqueId();
  }

  renderExtjsCmp() {}

  componentDidMount() {
    this.renderExtjsCmp();
  }

  getValue() {
    return null;
  }

  render() {
    return (
      <>
      <div
        id={this.renderTo}
        style={this.props.style}
        className={this.props.className}
      ></div>
      {window.appStore.containerStore.commentsPopoverData.isCommentsPopoverOpen && (
        <CommentsPopover
          open={window.appStore.containerStore.commentsPopoverData.isCommentsPopoverOpen}
          anchorEl={window.appStore.containerStore.commentsPopoverData.commentsPopoverAnchorEl}
          updateCount={()=>{}}
          list_id={window.appStore.containerStore.listId}
          row_id={window.appStore.containerStore.commentsPopoverData.commentsPopoverRowId}
          closePopper={() => {
            window.appStore.containerStore.commentsPopoverData = {
              isCommentsPopoverOpen: false,
              commentsPopoverRowId: null,
              commentsPopoverAnchorEl: null
            }
          }}
        />
      )}
      </>
    );
  }
}

export default observer(ExtjsReact);
